import { ensureStartApp } from '../../start'
import store from '../../store'
import { t } from '@/lib/i18n'

export function middlewares (router) {
  router.beforeEach(async (to, from, next) => {

    const showOverlay = store.state.overlay.show

    if (showOverlay) return

    const handle = () => {
      if (to.meta.noAuth) {
        return next(true)
      }
      const userSession = store.state.session.user
      if (!userSession) {
        return next('/')
      }
      // a ordem importa
      const fnsVerify = [
        verifyAdmin,
        verifySystemModules,
        verifyTags
      ]
      // verifica se todas as funcoes
      // de validacao de entrada
      // de rota permitem a entrada
      const canEnter = fnsVerify.every(fn => fn(userSession, to))
      if (!canEnter) {
        store.dispatch('notify/success', t('no_permission_access'))
      }
      next(canEnter)
    }

    ensureStartApp(handle)
  })
}

function verifyAdmin (userSession, to) {
  if (to.meta.admin) {
    return userSession.admin
  }
  return true
}

function verifySystemModules (userSession, to) {
  const { systemModule } = to.meta
  if (systemModule) {
    return userSession.systemmodules.includes(systemModule)
  }
  return true
}

function verifyTags (userSession, to) {
  const { tags, admin } = userSession
  // admin nao precisa de tag
  if (admin) {
    return true
  }
  const { tag } = to.meta
  // nenhuma permissao requerida na rota
  if (!tag) {
    return true
  }
  const hasPermission = tags.includes(tag)
  return hasPermission
}
